import { useState, useMemo } from 'react';
import { DashboardHeader } from './components/DashboardHeader';
import { AlertFeedWidget } from './components/AlertFeedWidget';
import { FlaggedCustomersWidget } from './components/FlaggedCustomersWidget';
import { RuleHitChartWidget } from './components/RuleHitChartWidget';
import { CaseStatusFunnelWidget } from './components/CaseStatusFunnelWidget';
import type { DateRange } from './types';

const DEFAULT_RANGE: DateRange = {
  start: '2026-07-07',
  end: '2026-08-06',
};

export default function App() {
  const [dateRange, setDateRange] = useState<DateRange>(DEFAULT_RANGE);

  const validRange = useMemo<DateRange>(() => {
    if (new Date(dateRange.start) > new Date(dateRange.end)) {
      return { start: dateRange.end, end: dateRange.end };
    }
    return dateRange;
  }, [dateRange]);

  return (
    <div className="min-h-screen p-4 sm:p-6 lg:p-8">
      <div className="mx-auto max-w-7xl">
        <DashboardHeader dateRange={dateRange} onDateRangeChange={setDateRange} />
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-6">
          <AlertFeedWidget dateRange={validRange} />
          <FlaggedCustomersWidget dateRange={validRange} />
          <RuleHitChartWidget />
          <CaseStatusFunnelWidget />
        </div>
      </div>
    </div>
  );
}
